import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';

import rootReducer from './reducers/index';

/**
 * @param {any} initialState
 * @param {any} history
 * @returns {ReturnType<typeof createStore>}
 */
export default function configureStore(initialState, history) {
  const finalCreateStore = compose(
    applyMiddleware(thunk),
    // eslint-disable-next-line no-undef
    __BROWSER__ ? applyMiddleware(routerMiddleware(history)) : (f) => f,

    typeof window === 'object' && typeof window.devToolsExtension !== 'undefined'
      ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f,
  )(createStore);

  return finalCreateStore(rootReducer(history), initialState);
}
